import { createUrl } from '../helpers/createUrl';
import { getPathnameFromHref } from '../helpers/getPathnameFromHref';
import type { ValidHref } from '../types';

export type PairGetLinkParams =
  /**
   * Pair a hardware device
   * pair it to a project page (C2C)
   * `/pair/:deviceCode`
   */
  {
    page: 'pair';
    deviceCode?: string;
  };

export const getLinkForPair = (params: PairGetLinkParams): ValidHref => {
  const { deviceCode } = params;

  return createUrl({
    pathname: deviceCode ? `/pair/${deviceCode}` : '/pair',
  });
};

export const isPairPageType = (href: ValidHref): boolean => {
  const pathname = getPathnameFromHref(href);
  const parts = pathname.split('/');
  return parts.length >= 2 && parts[1] === 'pair';
};
